// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".rtl-direction{direction:rtl}\n", "",{"version":3,"sources":["/home/sysadmin/apps/rsee-panel/src/routes/router.scss"],"names":[],"mappings":"AAAA,eACE,aAAc","file":"router.scss","sourcesContent":[".rtl-direction{\n  direction: rtl;\n}"]}]);
// Exports
module.exports = exports;
